import React from 'react';
import { Box } from '@gluestack-ui/themed';

/**
 * Thin vertical rule between health figures (not a card).
 */
export function HealthFigureDivider() {
  return (
    <Box
      width={1}
      alignSelf="stretch"
      bg="$borderLight"
      mx="$2"
      my="$2"
      testID="health-figure-divider"
    />
  );
}
